import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'

import store from '@/state/store'
import routes from './routes'

Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
})

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  if(to.name === "order detail" || to.name === "sample order detail"){
    next()
  }else {
    store.dispatch('authentication/verifyToken').then((result) => {
      if (result.payload){
        if(to.matched.some((route)=> route.meta.authPage)){
          next({name: 'dashboard'})
        }
      }else {
        // eslint-disable-next-line no-empty
        if(to.matched.some((route)=> route.meta.authPage)){
        }else {
          if(result === 'Signature has expired') {
            store.dispatch('authentication/logoutUser')
            next({name: 'login', query: { redirectFrom: to.fullPath } })
          } else if(result === 'Error decoding signature') {
            store.dispatch('authentication/logoutUser')
            next({name: 'login', query: { redirectFrom: to.fullPath } })
          }
        }
      }
    })
  }
  next()
})

const userPermissions = store.getters['authentication/userPermissions'];

router.beforeEach((to, from, next) => {
  const permissions = to.meta.permissions;
  if(to.name === "order detail" || to.name === "sample order detail"){
    next()
  }else if (permissions){
    let isAllowed = userPermissions.some( p => permissions.includes(p));
    if (!isAllowed) return next({name: 'dashboard'})
  }
  next()
})


export default router
